export default __webpack_public_path__ + "static/media/homeLogo.ce9f1c1d.svg";